<template>
  <div>
    <b-row
      class="match-height"
      sm="12"
    >
      <b-col sm="6">
        <!-- :loca="location" -->
        <weather-card
        ref="weatherCard"
        ></weather-card>
      </b-col>
      <b-col sm="6" v-show="comments.length > 0">
        <b-card class="bg-light-secondary text-center">
          <b-card-title>
              <b>스마트 장비 운영 지원</b>
            </b-card-title>
          <b-card-body v-for="cmt of comments" :key="cmt.title" class="m-1" :id="cmt.title">
            <b-card-title>
              <b >{{cmt.title}}</b>
            </b-card-title>
            <b style="white-space: pre" >{{cmt.comment}}</b>
            <b-tooltip v-if="cmt.title.split(' ')[1] === '사료급이기'" :ref="cmt.title" :target="cmt.title" placement="bottom" triggers="manual click">
              <b>THI 지수 "경고" 단계 이상부터 나오는 사료 섭취량 감소에 따라 권장드리는 사항입니다.</b>
            </b-tooltip>
            <hr style="border: 1px dotted">
          </b-card-body>
        </b-card>
      </b-col>
      <b-col sm="6">
        <device-status-card
        ref="deviceStatusCard"
        :ready="ready"
        ></device-status-card>
      </b-col>
      <b-col sm=6>
        <temp-humi-index-card
        ref="tempHumiIndexCard"
        ></temp-humi-index-card>
      </b-col>
    
      <b-col sm="6" v-for="sensor of sensorList" :key="sensor._id">
          <load-page v-show="sensorList.length < 1"></load-page>
          <sensor-graph-card
            v-show="sensor.values.length > 0 && sensorList.length > 0"
            :ref="sensor._id"
            :title="sensor.name"
            :ready="sensor.ready"
          />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BTooltip,
  BCardText,
  BCardBody,
  BCardTitle,
  BTable,
  BRow,
  BCard,
  BCol,
  BSpinner
} from 'bootstrap-vue'

import { getUserData } from '@/auth/utils'
import store from '@/store'
import SensorStateCard from './components/SensorStateCard.vue'
import WeatherCard from './components/WeatherCard.vue'
import SensorGraphCard from './components/SensorGraphCard.vue'
import TempHumiIndexCard from './components/TempHumiIndexCard.vue'
import DeviceStatusCard from './components/DeviceStatusCard.vue'
import LoadPage from '@/views/pages/utils/LoadPage.vue'
import dayjs from 'dayjs'

export default {
  components: {
    BTooltip,
    LoadPage,
    BCardText,
    BCardBody,
    BCardTitle,
    BTable,
    BCard,
    BSpinner,
    BRow,
    BCol,
    SensorStateCard,
    WeatherCard,
    SensorGraphCard,
    TempHumiIndexCard,
    DeviceStatusCard
  },
  data() {
    return {
      farmId: '',
      ready: false,
      sensorList: [],
      tableData: [],
      fields: [],
      sensors: {
        temperature: 0,
        humidity: 0,
      },
      thindex:{},
      deviceData: null,
      sensorData: null,
      location: null,
      error: null,
      comments: [],
      weather: {
        temperature: 0,
        humidity: 0,
        wind_speed: 0
      }
    }
  },
  created() {
    this.getLocation()
  },
  mounted() {
    
  },
  methods: {
    async getLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          position => {
            this.location = {
              latitude: position.coords.latitude,
              longitude: position.coords.longitude
            }
            this.error = null
          },
          error => {
            switch(error.code) {

              case error.PERMISSION_DENIED:
                this.error = "User denied the request for Geolocation."
                break
              case error.POSITION_UNAVAILABLE:
                this.error = "Location information is unavailable."
                break
              case error.TIMEOUT:
                this.error = "The request to get user location timed out."
                break
              case error.UNKNOWN_ERROR:
                this.error = "An unknown error occurred."
                break
            }
          }
        )
      } else this.error = "Geolocation is not supported by this browser."
    },
    async getSensor(farmId) {
      this.sensorList = []
      this.ready = false
      try{
        const res = await this.$refs.weatherCard.getWeatherData(this.location)
        this.weather.temperature = res.temperature
        this.weather.humidity = res.humidity
        this.weather.wind_speed = res.wind_speed

        this.sensorData = await this.$refs.tempHumiIndexCard.getSensors( farmId )
        
        this.deviceData = await this.$refs.deviceStatusCard.init( farmId )
        
        const sensorList = await store.dispatch('sensor/getSensorList', {
          userId: getUserData().id,
          farmId,
        })
        this.sensorList = sensorList
        
        //console.log('this.sensorList', this.sensorList)
        if(this.sensorList.length > 0) this.comments = await this.getComments(this.deviceData)
        this.ready = true;

        // 모든 센서 데이터 가져오기
        const sensorPromises = this.sensorList.map(async (sensor) => {
          const res = await store.dispatch('sensor/fetchSensor', { id: sensor._id })
          sensor.values = res.data.values
          sensor.ready = true

          // $refs 확인 후 UI 업데이트
          if (this.$refs[sensor._id]?.[0]) this.$refs[sensor._id][0].updateUI(sensor)
        })

        // 모든 비동기 작업 완료 대기
        await Promise.all(sensorPromises)

        

      } catch (error) {
        console.error(error)
      }
    },
    async getComments(deviceList) {

      const commentArr = []

      let power = 20
      const step = this.sensorData.thi.step
      if(step === '정상') {
         
          commentArr.push({
            title: 'THI 지수 안내',
            comment: `THI 지수가 정상 단계입니다. 👏🏻`
          })

          return commentArr
       
      }

      const data = await this.getTHIndex(this.sensorList)

      const inverterList = deviceList.inverter.filter(e => parseInt(e.power.split(' ')[0]) < power).map(e => e.name)
      const curtainList = deviceList.curtain.map(e => e.name)

      switch (step) {
        case '주의': power = 40; break;
        case '경고': power = 60; break;
        case '위험': power = 70; break;
        case '심각': power = 80; break;
        default: power = 0; break;
      }

      commentArr.push({
        title: `💡 인버터`,
        comment: `출력 ${power}% 이상으로 
조정하시기를 권장드립니다.`
      })

      commentArr.push({
          title: `💡 커튼`,
          comment: `현재 축사 온도가 ${this.sensorData.sensors['temperature']} ℃ 이므로
개방하는 것을 권장드립니다.`
        })

      commentArr.push({
        title: `💡 사료급이기`,
        comment: `사료 급여 추천 시간: ${data.min_time}
사료 급여 비추천 시간: ${data.max_time}`
      })
      //console.log('commentArr', commentArr)
      

      return commentArr
    },
    async getTHIndex(sensors) {
      const temp_sensor = sensors.find(el => el.type === 'temperature')
      const humi_sensor = sensors.find(el => el.type === 'humidity')
      const res = await store.dispatch('sensor/getTHIndex', { 
        tempId: temp_sensor._id,
        humiId: humi_sensor._id,
        date: dayjs().subtract(1, 'day').format('YYYY-MM-DD')
      })

      res.data.min_time = dayjs(res.data.min_time).format('HH시 mm분')
      res.data.max_time = dayjs(res.data.max_time).format('HH시 mm분')

      return res.data
    },
  },
}
</script>

<style>


</style>
